import PropTypes from 'prop-types';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import { AddressInput, Col, Row, TextInput } from '@figure/frontlib-gui';

const AddressSectionForm = ({ id, label, fieldName, values, touched, errors, setFieldValue }) => (
  <>
    <Row>
      <Col sm={12}>
        <AddressInput
          id={`${id}-street1`}
          label={label}
          data-test-id={`${fieldName}-street1`}
          value={values[fieldName].street1}
          placeholder="123 Main Street"
          cancelable
          errorText={touched[fieldName]?.street1 && errors[fieldName]?.street1}
          onChange={(v) => {
            setFieldValue(`${fieldName}.street1`, v);
            ['street2', 'city', 'state', 'zip'].forEach((subField) =>
              setFieldValue(`${fieldName}.${subField}`, '')
            );
          }}
          autoComplete={`new-${fieldName}-street1`}
          onAutocompleteSelection={(address) =>
            ['street1', 'street2', 'city', 'state', 'zip'].forEach((subField) =>
              setFieldValue(`${fieldName}.${subField}`, address[subField])
            )
          }
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <TextInput
          id={`${id}-street2`}
          label="Apartment, suite, or unit"
          data-test-id={`${fieldName}-street2`}
          value={values[fieldName].street2}
          maxLength="128"
          placeholder={!values[fieldName].street1 && 'Apt 10'}
          errorText={touched[fieldName]?.street2 && errors[fieldName]?.street2}
          autoComplete={`new-${fieldName}-street2`}
          onChange={(e) => setFieldValue(`${fieldName}.street2`, e.target.value)}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={4}>
        <TextInput
          id={`${id}-city`}
          label="City"
          data-test-id={`${fieldName}-city`}
          value={values[fieldName].city}
          maxLength="128"
          placeholder={!values[fieldName].street1 && 'Anytown'}
          errorText={touched[fieldName]?.city && errors[fieldName]?.city}
          onChange={(e) => setFieldValue(`${fieldName}.city`, e.target.value)}
          autoComplete={`new-${fieldName}-city`}
          required
        />
      </Col>

      <Col sm={4}>
        <TextInput
          id={`${id}-state`}
          label="State"
          data-test-id={`${fieldName}-state`}
          value={values[fieldName].state}
          maxLength="2"
          placeholder={!values[fieldName].street1 && 'CA'}
          errorText={touched[fieldName]?.state && errors[fieldName]?.state}
          onChange={(e) => setFieldValue(`${fieldName}.state`, e.target.value.toUpperCase())}
          autoComplete={`new-${fieldName}-state`}
          required
        />
      </Col>

      <Col sm={4}>
        <TextInput
          id={`${id}-zip`}
          label="Zip"
          data-test-id={`${fieldName}-zip`}
          value={values[fieldName].zip}
          maxLength="10"
          placeholder={!values[fieldName].street1 && '99999'}
          errorText={touched[fieldName]?.zip && errors[fieldName]?.zip}
          onChange={(e) => setFieldValue(`${fieldName}.zip`, e.target.value)}
          autoComplete={`new-${fieldName}-zip`}
          required
        />
      </Col>
    </Row>
  </>
);

AddressSectionForm.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  values: reduxPropTypes.address.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

AddressSectionForm.defaultProps = {
  label: 'Address',
};

export default AddressSectionForm;
